<template>
  <c-q-btn
    v-if="authStore.currentUserCanCancelInstitutional
    && (institutionalStore.institutionalDetail?.status == CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id
      || institutionalStore.institutionalDetail?.status == CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id
      || institutionalStore.institutionalDetail?.status == CONST_INSTITUTIONAL_STATUS.REAPPROVED.id)"
    id="btn-discard-changes"
    propBtnLabel="Descartar Alterações"
    :propBtnFunction="onDiscardChangesBtnClick"
    :propBtnTransparent="true"
    :propBtnSize="EnumButtonSizes.LARGE_1"
  />
</template>

<script setup lang="ts">
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import messages from '@/utils/messages'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { EnumButtonSizes, EnumRouteNames }	from '@/enums/enums';
import { useRouter }						from 'vue-router';

const router = useRouter();
const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

const onDiscardChangesBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.discardChanges(id)

    messages.showSuccessMsg("Alterações descartadas com sucesso!")

    
  // ✅ REDIRECIONA PRA LISTAGEM
    router.push({
      name: EnumRouteNames.INSTITUTIONAL_SEARCH
    })


  } catch (error) {
    messages.showErrorMsg("Erro ao tentar descartar alterações...")

  } finally {
    pagesUtilStore.showLoading = false
  }
}


</script>

<style scoped>
</style>

